import * as serviceWorker from "./serviceWorker";
import App from "./App";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";

import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAgfK-TOg1mcFizEbdq2earV9xUzYSTv3E",
  authDomain: "handtoy-school-8db6e.firebaseapp.com",
  projectId: "handtoy-school-8db6e",
  storageBucket: "handtoy-school-8db6e.firebasestorage.app",
  messagingSenderId: "959722064661",
  appId: "1:959722064661:web:37035b8942e503a584b71c",
  measurementId: "G-B2FP9DTB22",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
